import { SendLixiRequest } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const postApplicationSendLixiXml = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: SendLixiRequest,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/lixi-xml`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
